/** Ids generated in the editor (browser) — Web Crypto works there and in Node. */
const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

function base36(len: number): string {
  const bytes = new Uint8Array(len);
  globalThis.crypto.getRandomValues(bytes);
  let out = "";
  for (const b of bytes) out += ALPHABET[b % 36];
  return out;
}

function unique(make: () => string, taken?: Set<string>): string {
  for (;;) {
    const id = make();
    if (!taken || !taken.has(id)) return id;
  }
}

/** Stable question id ('q_' + 8 base36). Never reused within a survey. */
export function newQuestionId(taken?: Set<string>): string {
  return unique(() => "q_" + base36(8), taken);
}

/** Stable option key ('o_' + 6 base36). */
export function newOptionKey(taken?: Set<string>): string {
  return unique(() => "o_" + base36(6), taken);
}
